var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 9px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,241.58c-64.84,0-117.6-52.76-117.6-117.6,0-64.04,50.14-115.67,114.15-117.55h.19c3.35,0,6.12,2.67,6.22,6.05.1,3.44-2.61,6.31-6.05,6.41-57.23,1.68-102.06,47.84-102.06,105.1,0,57.98,47.17,105.15,105.15,105.15,57.97,0,105.14-47.17,105.14-105.15,0-28.89-12.08-56.56-32.8-76.26v18.95c0,3.44-2.79,6.23-6.23,6.23s-6.23-2.79-6.23-6.23v-32.31c0-.24.11-.45.14-.68.05-.43.12-.83.25-1.24.14-.41.32-.78.54-1.15.12-.2.15-.43.29-.63.09-.13.23-.19.33-.3.28-.33.61-.6.95-.87.31-.23.6-.46.94-.63.35-.18.71-.28,1.09-.39.42-.12.82-.22,1.25-.25.16-.01.29-.09.45-.09h32.17c3.44,0,6.23,2.79,6.23,6.23s-2.79,6.23-6.23,6.23h-15.46c21.99,21.9,34.77,51.98,34.77,83.39,0,64.84-52.75,117.6-117.6,117.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.1b9e1b5cc7bfeeb2157d04241b4bdb0f.svg";
export { ForwardRef as ReactComponent };